import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import style from "./index.module.less";
import { isIOS, getBrowserEnv } from "@/utils/tools";

type propsType = {
  children?: React.ReactNode;
  footerRender?: Function;
  title?: string;
  navHeight?: number;
};

const PageContainer = forwardRef((props: propsType, ref) => {
  const { isXPApp } = getBrowserEnv();
  const { footerRender, title } = props;
  const [footerHeight, setFooterHeight] = useState(0);
  const [contentHeight, setContentHeight] = useState(window.innerHeight);
  const footerRef = useRef<HTMLDivElement>(null);
  const divRef = useRef<HTMLDivElement>(null);
  const getScreenHeight = function () {
    if (isIOS()) {
      console.log("===ios===");
      return window.innerHeight;
    }
    return document.documentElement
      ? document.documentElement.clientHeight
      : window.innerHeight;
  };

  const setHeight = () => {
    if (footerRef?.current) {
      const footerHeight = footerRef?.current?.clientHeight || 0;
      console.log("%c Line:24 🌽 footerHeight", "color:#ed9ec7", footerHeight);
      setFooterHeight(footerHeight);
    }
  };
  useImperativeHandle(ref, () => {
    return {
      reset: () => {
        console.log("%c Line:44 🍔 setHeight", "color:#7f2b82");
        setHeight();
      },
    };
  });

  useEffect(() => {
    setHeight();
  }, [footerRender]);

  useEffect(() => {
    if (title != undefined) {
      document.title = title;
    }
  }, [title]);

  useEffect(() => {
    // 安卓加载页面会触发 resize ，ios 偶尔不会， 会导致高度获取不对
    const fun = () => {
      const height = getScreenHeight();
      setContentHeight(height);
      console.log("=====height=====", height);
    };
    fun();
    window.addEventListener("resize", fun);
    return () => {
      console.log("=====pageContainer destory=====");
      window.removeEventListener("resize", fun);
    };
  }, []);

  useEffect(() => {
    const fn = () => {
      setHeight();
    };
    // 处理安卓手机软键盘顶起footer元素问题
    document.addEventListener("focusout", fn);
    return () => {
      document.removeEventListener("focusout", fn);
    };
  }, []);
  console.log("=====contentHeight=====", contentHeight);
  console.log("====clientHeight====", document.documentElement.clientHeight);
  console.log("====screenHeight====", window.screen.height);
  console.log("====innerHeight====", window.innerHeight);
  //ios 使用内联样式获取高度
  return (
    <div
      className={style["pageContainer"]}
      style={{
        height:
          (isIOS() ? window.innerHeight : contentHeight) -
          (isXPApp ? props.navHeight || 0 : 0) +
          "px",
      }}
    >
      <div
        style={{
          height:
            (isIOS() ? window.innerHeight : contentHeight) -
            footerHeight -
            (isXPApp ? props.navHeight || 0 : 0) +
            "px",
        }}
        ref={divRef}
      >
        {props.children}
      </div>
      {footerRender && <div ref={footerRef}>{footerRender()}</div>}
    </div>
  );
});

export default PageContainer;
